import { lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import ActiveUsersPage from './pages/ActiveUsersPage';
// Lazy load all page components
const ADMEStatusPage = lazy(() => import('./pages/ADMEStatusPage').then(m => ({ default: m.ADMEStatusPage })));
const GroupsPage = lazy(() => import('./pages/GroupsPage').then(m => ({ default: m.GroupsPage })));
const GroupDetailsPage = lazy(() => import('./pages/GroupDetailsPage').then(m => ({ default: m.GroupDetailsPage })));
const HealthPage = lazy(() => import('./pages/HealthPage').then(m => ({ default: m.HealthPage })));
const InfoPage = lazy(() => import('./pages/InfoPage').then(m => ({ default: m.InfoPage })));
const CheckMembershipPage = lazy(() => import('./pages/operations/CheckMembershipPage').then(m => ({ default: m.CheckMembershipPage })));
const ServiceGroupsPage = lazy(() => import('./pages/ServiceGroupsPage').then(m => ({ default: m.ServiceGroupsPage })));
const MemberDetailsPage = lazy(() => import('./pages/MemberDetailsPage').then(m => ({ default: m.MemberDetailsPage })));
const MonitoringPage = lazy(() => import('./pages/MonitoringPage').then(m => ({ default: m.MonitoringPage })));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const DataExplorerPage = lazy(() => import('./pages/DataExplorerPage'));
const LogsPage = lazy(() => import('./pages/LogsPage').then(m => ({ default: m.LogsPage })));
const ApiHealthPage = lazy(() => import('./pages/ApiHealth'));

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <EnvironmentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                {/* Public routes */}
                <Route path="login" element={<LoginPage />} />

                {/* Protected routes */}
                <Route element={<ProtectedRoute />}>
                  <Route index element={<HomePage />} />
                  <Route path="status" element={<ADMEStatusPage />} />
                  <Route path="groups" element={<GroupsPage />} />
                  <Route path="groups/:groupEmail" element={<GroupDetailsPage />} />
                  <Route path="health" element={<HealthPage />} />
                  <Route path="info" element={<InfoPage />} />
                  <Route path="service-groups" element={<ServiceGroupsPage />} />
                  <Route path="monitoring" element={<MonitoringPage />} />
                  <Route path="search" element={<SearchPage />} />
                  <Route path="data-explorer" element={<DataExplorerPage />} />
                  <Route path="logs" element={<LogsPage />} />
                  <Route path="api-health" element={<ApiHealthPage />} />
                  <Route path="active-users" element={<ActiveUsersPage />} />
                  <Route path="member/:memberId" element={<MemberDetailsPage />} />

                  {/* Operations routes */}
                  <Route path="operations/check-membership" element={<CheckMembershipPage />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </EnvironmentProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
